import { createFileRoute } from "@tanstack/react-router";
import { AccessProfileListFeature } from "@/features/access-profile-list";

function AccessProfilesPage() {
  return <AccessProfileListFeature />;
}

export const Route = createFileRoute("/access-profiles/")({
  component: AccessProfilesPage,
  staticData: { authorize: true },
});
